export const MapEventEnum = Object.freeze({
  click: "click",
  rightClick: "rightclick",
  dragEnd: "dragEnd",
  cameraChanging: "cameraChanging",
  tilesLoaded: "tilesLoaded",
  hover: "hover",
  mouseOut: "mouseout",
  mouseMove: "mousemove",
  mouseOver: "mouseover"
})
